'use strict';

document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'playVideo', ( service, code ) => ({

		service    : service,
		code       : code,
		isPlaying  : false,
		youTubeUrl : '//www.youtube.com/embed/',
		vimeoUrl   : '//player.vimeo.com/video/',
		iframeParam: '?autoplay=1',

		iframeUrl() {

			if ( 'vimeo' === this.service ) {
				const embedUrl = this.vimeoUrl + this.code;
				return embedUrl + this.iframeParam;
			}

			const embedUrl = this.youTubeUrl + this.code;
			return embedUrl + this.iframeParam;
		}

	}) );
});
